module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_5.bfea307e.png";